import { getRequest, postRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import {
    failureBuyAddressSubscription,
    failureChangeShippingAddress,
    failureVerifyPrimaryAddress,
    successBuyAddressSubscription,
    successChangeShippingAddress,
    successGetAddressesSubscriptions,
    successVerifyPrimaryAddress,
} from './addresses-actions'
import AddressesActionTypes from './addresses-types'

function* getAddressesSubscriptions() {
    try {
        const { data } = yield getRequest(`/user/virtualAddresses/subscriptions/available`)
        yield put(successGetAddressesSubscriptions(data))
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log('error getAddressesSubscriptions')
        }
    }
}

export function* onGetAddressesSubscriptions() {
    yield takeLatest(AddressesActionTypes.START_GET_ADDRESSES_SUBSCRIPTIONS, getAddressesSubscriptions)
}

function* startBuyAddressSubscription({ payload: { id } }) {
    try {
        const { data } = yield postRequest(`/user/virtualAddresses/subscriptions/${id}/buy`)
        yield put(successBuyAddressSubscription(data))
    } catch (err) {
        yield put(failureBuyAddressSubscription({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error getAddressesSubscriptions')
        }
    }
}

export function* onBuyAddressSubscription() {
    yield takeLatest(AddressesActionTypes.START_BUY_ADDRESS_SUBSCRIPTION, startBuyAddressSubscription)
}

function* startChangeShippingAddress({ payload: { streetAddress, city, zipCode, countryCode } }) {
    try {
        const { data } = yield postRequest(`/identity/addresses/shipping`, { streetAddress, city, zipCode, countryCode })
        yield put(successChangeShippingAddress(data))
    } catch (err) {
        yield put(failureChangeShippingAddress({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('error startChangeShippingAddress')
        }
    }
}

export function* onChangeShippingAddress() {
    yield takeLatest(AddressesActionTypes.START_CHANGE_SHIPPING_ADDRESS, startChangeShippingAddress)
}

function* startVerifyPrimaryAddress({ payload: { formData } }) {
    try {
        yield postRequest('/identity/addresses/primary/verify', formData)
        yield put(successVerifyPrimaryAddress())
    } catch (err) {
        yield put(failureVerifyPrimaryAddress({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('failureVerifyProofOfAddress')
        }
    }
}

export function* onStartVerifyPrimaryAddress() {
    yield takeLatest(AddressesActionTypes.START_VERIFY_PRIMARY_ADDRESS, startVerifyPrimaryAddress)
}

export function* addressesSagas() {
    yield all([call(onGetAddressesSubscriptions), call(onBuyAddressSubscription), call(onChangeShippingAddress), call(onStartVerifyPrimaryAddress)])
}
